/**
 * orga-app-api - kontaktverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KontaktBooleanRequest { 
    kontakt_id: string;
    wert?: boolean;
    funktionsbereich_id: string;
}

